var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",attrs:{"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var valid = ref.valid;
var pending = ref.pending;
var errors = ref.errors;
var handleSubmit = ref.handleSubmit;
return [_c('form',_vm._b({on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm._submitHandler)}}},'form',_vm.$attrs,false),[_vm._t("default",null,{"meta":{ valid: valid, pending: pending, currentValues: _vm.currentValues, dirty: _vm.dirty },"isSubmitting":_vm.isSubmitting,"setFieldValue":_vm._setCurrentValue,"errors":// errors object has changed shape from v3 to v4
        // old shape: { a: [], b: ['bad B'] }  see: https://vee-validate.logaretm.com/v3/api/validation-observer.html#scoped-slot-props
        // new shape: { b: 'bad B' }           see: https://vee-validate.logaretm.com/v4/guide/components/validation#using-the-form-slot-props
        Object.fromEntries(
          Object.entries(errors)
            // only fields with error messages are included in the object
            .filter(function (ref) {
                    var field = ref[0];
                    var errors = ref[1];

                    return errors.length > 0;
})
            // only the first error message for each field is displayed
            .map(function (ref) {
                    var field = ref[0];
                    var errors = ref[1];

                    return [field, errors[0]];
})
        )})],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }